import { bool, number, object } from "prop-types";
import { createElement, forwardRef, memo } from "react";

import classes from "./DocXContentNode.module.scss";
import useMarkContentByTerms from "./hooks/useMarkContentByTerms";
import TermDescriptionHoverTooltip from "./TermDescriptionHoverTooltip";

const DocXContentNode = forwardRef(
  ({ hasSinglePage, index, data }, forwardedRef) => {
    const type = hasSinglePage ? "article" : "div";
    const originalHtml = data.outerHTML;
    const { ref } = useMarkContentByTerms();

    return createElement(
      type,
      {
        className: classes.docx_node,
        "data-index": index,
        ref: forwardedRef,
      },
      <>
        <div dangerouslySetInnerHTML={{ __html: originalHtml }} ref={ref} />
        <TermDescriptionHoverTooltip containerRef={ref} />
      </>
    );
  }
);

DocXContentNode.displayName = "DocXParagraph";

DocXContentNode.propTypes = {
  hasSinglePage: bool,
  index: number,
  data: object,
};

export default memo(DocXContentNode);
